"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AuthStrategy = void 0;
var AuthStrategy;
exports.AuthStrategy = AuthStrategy;

(function (AuthStrategy) {
  AuthStrategy["AUTH_ZERO"] = "auth0";
})(AuthStrategy || (exports.AuthStrategy = AuthStrategy = {}));

var createAuthService = function createAuthService(_ref) {
  var strategy = _ref.strategy,
      tokenService = _ref.tokenService,
      appHost = _ref.appHost,
      apiHost = _ref.apiHost,
      returnUrl = _ref.returnUrl,
      callbackUrl = _ref.callbackUrl;
  var loginUrl = "".concat(apiHost, "/auth/login?callbackUrl=").concat(callbackUrl);
  var logoutUrl = "".concat(apiHost, "/auth/logout?returnUrl=").concat(returnUrl);
  return Object.freeze({
    appHost,
    apiHost,
    strategy,
    tokenService,
    callbackUrl,
    returnUrl,
    loginUrl,
    logoutUrl
  });
};

var _default = createAuthService;
exports.default = _default;